import { render } from "./Sidebar.vue?vue&type=template&id=8490eefe"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
script.render = render

export default script